import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturedManga from './components/FeaturedManga';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function Home() {
  useEffect(() => {
    document.title = '漫境｜成人漫画精选推荐 — 高质内容一站畅览';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        '漫境为您精选正版授权成人漫画内容，涵盖悬疑惊悚、都市情感、历史传奇、科幻奇幻等多种风格。安全、合规、私密的成人漫画在线阅读平台，满足成熟读者对深度故事与艺术画风的多元需求。'
      );
    }
  }, []);

  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />
      <main>
        <HeroSection />
        <FeaturedManga />
        <CategoryGrid />
        <LatestUpdates />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}